import { ArrowLeft, Upload } from 'lucide-react';
import { useRef } from 'react';
import { CanvasPreview } from '../components/CanvasPreview';
import { Inspector } from '../components/Inspector';
import { PresetRail } from '../components/PresetRail';
import { usePhoto } from '../context/PhotoContext';
import { useLanguage } from '../i18n';
import { navigate } from '../App';

export function EditorPage(): JSX.Element {
  const inputRef = useRef<HTMLInputElement>(null);
  const { activePhoto, settings, loadFiles, resetPhoto } = usePhoto();
  const { t } = useLanguage();

  if (!activePhoto) {
    return (
      <main className="mx-auto flex min-h-[calc(100vh-3.5rem)] max-w-3xl flex-col items-center justify-center px-4 text-center">
        <h1 className="text-2xl font-semibold">{t('editor.noPhotoTitle')}</h1>
        <p className="mt-3 text-sm leading-6 text-[color:var(--muted)]">{t('editor.noPhotoBody')}</p>
        <button className="primary-button mt-6" onClick={() => navigate('/')}>
          <ArrowLeft size={16} />
          {t('editor.backUpload')}
        </button>
      </main>
    );
  }

  return (
    <main className="lg:flex">
      <PresetRail />
      <section className="min-w-0 flex-1">
        <div className="flex items-center justify-between gap-3 border-b border-[color:var(--line)] bg-[color:var(--surface)] px-4 py-3">
          <button className="icon-button gap-2" onClick={resetPhoto}>
            <ArrowLeft size={16} />
            {t('editor.newPhoto')}
          </button>
          <button className="icon-button gap-2" onClick={() => inputRef.current?.click()}>
            <Upload size={16} />
            {t('editor.addBatch')}
          </button>
          <input
            ref={inputRef}
            type="file"
            className="sr-only"
            accept="image/jpeg,image/png,image/webp,image/heic,image/heif,.heic,.heif"
            multiple
            onChange={(event) => {
              if (event.target.files) void loadFiles(event.target.files);
              event.currentTarget.value = '';
            }}
          />
        </div>
        <CanvasPreview photo={activePhoto} settings={settings} />
      </section>
      <Inspector />
    </main>
  );
}
